// extracted by mini-css-extract-plugin
export default {"image":"discount-info-dialog__image___X9RgN"};